import { memo } from 'react';

import { FilePenLineIcon, PaintbrushVerticalIcon, TagsIcon } from '@air/design-icons';

import { WorkspaceAgentNextActionButton } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/next-actions/WorkspaceAgentNextActionButton';

export type WorkspaceAgentNextActionsProps = {
  onMakeVariants: () => void;
  onRename: () => void;
  onTag: () => void;
};

export const WorkspaceAgentNextActions = memo(({ onMakeVariants, onRename, onTag }: WorkspaceAgentNextActionsProps) => (
  <div className="flex flex-col gap-1.5" data-testid="WORKSPACE_AGENT_NEXT">
    <p className="font-medium ads:text-metadata text-12 text-gray-10">What&apos;s next?</p>
    <div className="flex flex-wrap gap-2">
      <WorkspaceAgentNextActionButton
        icon={PaintbrushVerticalIcon}
        label="Edit more"
        onSelect={onMakeVariants}
        testId="WORKSPACE_AGENT_NEXT_VARIANTS"
      />
      <WorkspaceAgentNextActionButton
        icon={FilePenLineIcon}
        label="Rename"
        onSelect={onRename}
        testId="WORKSPACE_AGENT_NEXT_RENAME"
      />
      <WorkspaceAgentNextActionButton icon={TagsIcon} label="Tag" onSelect={onTag} testId="WORKSPACE_AGENT_NEXT_TAG" />
    </div>
  </div>
));

WorkspaceAgentNextActions.displayName = 'WorkspaceAgentNextActions';
